import moment from '../../../modules/moment';

export default {
    /**
     * Return the duration of the current search
     *
     * @param state
     */
    duration(state) {
        const momentStartDate = new moment(`${ state.currentSearch.start_date } ${ state.data.start_time }`, 'DD-MM-YYYY HH:mm');
        const momentEndDate = new moment(`${ state.currentSearch.end_date } ${ state.data.end_time }`, 'DD-MM-YYYY HH:mm');

        return momentEndDate.diff(momentStartDate, 'hours', true).toFixed(1).replace('.0', '');
    },

    /**
     * Return if the current search is long term
     *
     * @param state
     *
     * @returns {boolean}
     */
    isLongTerm(state) {
        return state.data.rental === 'long';
    },

    /**
     * Return if the current search is short term
     *
     * @param state
     *
     * @returns {boolean}
     */
    isShortTerm(state) {
        return state.data.rental === 'short';
    },
};
